import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RangeChart from '../../RangeChart/RangeChart';
import { currencyFormatter } from '../../Modules/JobRanges/Utils/Utils';
import classnames from 'classnames';
import './PSRangeChart.scss';

const propTypes = {
  className: PropTypes.string,
  rangeValues: PropTypes.array, // array of 3 numbers (min, avg, max)
  width: PropTypes.number,
  colors: PropTypes.array,
  roundTo: PropTypes.number,
  payType: PropTypes.string, // annual or hourly
  scaleMax: PropTypes.number,
  scaleMin: PropTypes.number,
  id: PropTypes.string,
  spaceBottom: PropTypes.bool
};

const defaultProps = {
  width: 350,
  colors: ['#2D67B9', '#5389D5'] // $c4, $c4-light
};

export default class PSRangeChart extends Component {
  static propTypes = propTypes;

  static defaultProps = defaultProps;

  constructor(props) {
    super(props);
  }

  bottomLabelFormatter = (val, index, context) => {
    if (index === 1) return '';
    return currencyFormatter(val, { ...context });
  };

  render() {
    const { rangeValues, className, width, colors, roundTo, payType, id, scaleMax, scaleMin, spaceBottom } = this.props;
    return (
      <RangeChart
        className={classnames(className)}
        labelsVisible
        data={rangeValues}
        height={20}
        width={width}
        scaleMax={scaleMax}
        scaleMin={scaleMin}
        barHeight={15}
        bottomLabelFormatter={this.bottomLabelFormatter}
        hasPointer={false}
        hideTopLabels
        labelToBarSpacingTop={!spaceBottom ? 5 : null}
        labelToBarSpacingBottom={spaceBottom ? 15 : null}
        labelToLabelMinSpacing={50}
        invertLabels={!spaceBottom}
        colors={colors}
        roundToNearest={roundTo}
        payType={payType}
        id={id}
        labelTextAnchor={['start', 'middle', 'end']}
      />
    );
  }
}
